/**
 * Маски ввода телефона и даты (доработка M2-1 п. 2, БЛ M2 1.4).
 *
 * Скобки, пробелы, дефисы и точки ставит маска, человек набирает цифры.
 * Нормализует и проверяет номер по-прежнему сервер (ТЗ M2 5.2) — маска
 * только помогает набрать.
 */

const digitsOf = (value: string) => value.replace(/\D/g, '');

/**
 * Телефон: `+7 (___) ___-__-__`. Первая набранная 8 или 7 — это код
 * страны, он становится «+7». Номер с «+» и кодом не 7 — иностранный:
 * маска отключается, номер вводится как есть.
 */
export function maskPhone(raw: string): string {
  const value = raw.trim();
  if (value === '+') return '+';
  if (/^\+[0-689]/.test(value)) return raw;
  let d = digitsOf(raw);
  if (d === '') return '';
  if (d[0] === '7' || d[0] === '8') d = d.slice(1);
  d = d.slice(0, 10);
  if (d === '') return '+7';
  return (
    `+7 (${d.slice(0, 3)}` +
    (d.length > 3 ? `) ${d.slice(3, 6)}` : '') +
    (d.length > 6 ? `-${d.slice(6, 8)}` : '') +
    (d.length > 8 ? `-${d.slice(8, 10)}` : '')
  );
}

/** Дата: `ДД.ММ.ГГГГ`, точки ставятся сами. */
export function maskDate(raw: string): string {
  const d = digitsOf(raw).slice(0, 8);
  return d.slice(0, 2) + (d.length > 2 ? `.${d.slice(2, 4)}` : '') + (d.length > 4 ? `.${d.slice(4, 8)}` : '');
}

/**
 * Новое значение поля с маской. Если человек стёр только знак маски —
 * скобку, пробел, дефис или точку, — цифры не изменились, и маска вернула
 * бы прежнюю строку: курсор «застревает». Поэтому стирается и цифра
 * слева от курсора, как если бы знака маски не было вовсе.
 */
export function maskedChange(prev: string, raw: string, caret: number | null, mask: (v: string) => string): string {
  if (caret !== null && raw.length < prev.length && digitsOf(raw) === digitsOf(prev)) {
    const before = digitsOf(raw.slice(0, caret)).length;
    if (before > 0) {
      const all = digitsOf(raw);
      return mask(all.slice(0, before - 1) + all.slice(before));
    }
  }
  return mask(raw);
}
